module.exports = __webpack_public_path__ + "static/IDM-76e8f206059bda516aac201801cb8fd2.gif";